export const CROWDFUNDING_ABI = `[
  {
      "type": "function",
      "name": "fundProject",
      "inputs": [
          {
              "name": "amount",
              "type": "uint256",
              "internalType": "uint256"
          },
          {
              "name": "token",
              "type": "address",
              "internalType": "address"
          },
          {
              "name": "to",
              "type": "address",
              "internalType": "address"
          },
          {
              "name": "uri",
              "type": "string",
              "internalType": "string"
          },
          {
              "name": "projectId",
              "type": "string",
              "internalType": "string"
          }
      ],
      "outputs": [],
      "stateMutability": "payable"
  },
  {
      "type": "event",
      "name": "ProjectFunded",
      "inputs": [
          {
              "name": "projectId",
              "type": "string",
              "indexed": false,
              "internalType": "string"
          },
          {
              "name": "tokenId",
              "type": "uint256",
              "indexed": false,
              "internalType": "uint256"
          },
          {
              "name": "collection",
              "type": "address",
              "indexed": false,
              "internalType": "address"
          },
          {
              "name": "funderAddress",
              "type": "address",
              "indexed": false,
              "internalType": "address"
          },
          {
              "name": "projectOwner",
              "type": "address",
              "indexed": false,
              "internalType": "address"
          },
          {
              "name": "fundAmount",
              "type": "uint256",
              "indexed": false,
              "internalType": "uint256"
          },
          {
              "name": "fundToken",
              "type": "address",
              "indexed": false,
              "internalType": "address"
          }
      ],
      "anonymous": false
  }
]`